<!--  -->
<template>
  <div class="carbon-container">
    <div class="screen-select">
      <div :class="['select-item', activeIndex === index ? 'active' : '']" v-for="(item, index) in selectList"
        :key="index" @click="handleItemClick(index)">
        {{ item.label }}
      </div>
    </div>
    <div class="table">
      <dispatch-table :columnData="columnDatas" :table-data="tableDatas" />
    </div>
    <!-- <el-table :data="tableData" :height="height"
      ><el-table-column prop="buildName" label="区域名称" width="80">
      </el-table-column>
      <el-table-column prop="energyQuantity" label="能耗总量" width="170">
      </el-table-column
      ><el-table-column prop="carbonEmission" label="碳排总量" width="170">
      </el-table-column>
    </el-table> -->
  </div>
</template>

<script>
import DispatchTable from "@ISS/situation/components/dispatchTable";

import API from "../api/index";
export default {
  props: {
    topNum: {
      type: Number,
      default: 5,
    },
    height: {
      type: Number,
      default: 280,
    },
  },
  data() {
    return {
      tableDatas: [],
      columnDatas: [
        {
          label: "序号",
          prop: "index",
          width: 60,
        },
        {
          label: "回路名称",
          prop: "deviceName",
          width: 180,
        },
        {
          label: "能耗总量",
          prop: "energyQuantity",
        },
        {
          label: "碳排总量",
          prop: "carbonEmission",
        },
      ],
      selectList: [
        {
          label: "当日",
          value: "3",
        },
        {
          label: "当月",
          value: "2",
        },
        {
          label: "当年",
          value: "1",
        },
      ],
      activeIndex: 0,
      statType: "3",
      //   tableData: [],
    };
  },

  components: {
    DispatchTable,
  },

  // computed() {},

  mounted() {
    this.queryData();
  },

  methods: {
    handleItemClick(index) {
      this.statType = this.selectList[index].value;
      this.activeIndex = index;
      this.queryData();
    },
    queryData() {
      this.tableDatas = []
      this.$fetch(API.carbonByDay + "?type=" + this.statType).then((res) => {
        if (res.success) {
          const dataArr = res.returnObj.splice(0, this.topNum);
          for (let i = 0; i < dataArr.length; i++) {
            let obj = {
              deviceName: dataArr[i].deviceName,
              queryDate: dataArr[i].queryDate,
              deviceId: dataArr[i].deviceId,
              energyQuantity: dataArr[i].energyQuantity ? (Number(dataArr[i].energyQuantity)).toFixed(2) : 0,
              carbonEmission: dataArr[i].carbonEmission ? (Number(dataArr[i].carbonEmission)).toFixed(2) : 0,
            };
            this.tableDatas.push(obj);
          }
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.carbon-container {
  position: relative;
  height: 100%;
}

.screen-select {
  display: flex;
  position: absolute;
  right: 0px;
  top: -48px;
  z-index: 999;

  .select-item {
    width: 60px;
    height: 24px;
    background: #000119;
    border: 1px solid #3f4163;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, 0.7);
    cursor: pointer;
    font-size: 12px;

    &.active {
      background: #15a0f6;
      color: #ffffff;
    }
  }
}

.table {
  height: 90%;
  padding-top: 10px;
}
</style>
